import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { usePrompt } from '../../../../util/PromptUtil';
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../../../../component/BreadCrumb';
import InputBox from '../../../../component/InputBox';
import SelectionBox from '../../../../component/SelectionBox';
import BoardPupupCheck from '../../../../component/BoardPupupCheck';
import CodeUtil from '../../../../util/CodeUtil';
import {
    CODE_GROUP_ID,
    COMMUNITY_QNA_DETAIL_PATH,
    COMMUNITY_QNA_PATH,
    PATH_DELIMITER,
    ROLE,
} from '../../../../constant/Constant';
import TextViewer from '../../../../component/editor/TextViewer';
import PopupRef from '../../../../component/PopupRef';
import TextEditor from '../../../../component/editor/TextEditor';
import CommunityPostEditorInfoBox from '../../../../component/CommunityPostEditorInfoBox';
import { actionEdit, actionDetail, actionRemove } from '../../../../module/body/community/qna/CommunityQnaModule';
import { VIEW_COMMUNITY_QNA_EDIT } from '../../../../constant/ViewConstant';
import CancelButtonBox from '../../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import MultiFileAttachBox from '../../../../component/MultiFileAttachBox';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import CommunityDeleteButtonBox from '../../../../component/buttons/CommunityDeleteButtonBox';

const CommunityQnaEditView = () => {
    // const auth = AuthenticationUtil.get();
    // usePrompt('현재 페이지를 벗어나시겠습니까?', true);
    let params = useParams();

    // condition
    const [postingNo, setPostingNo] = useState(params && params.postingNo);
    const [postingTypeCd, setPostingTypeCd] = useState('');
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [answerStatusCd, setAnswerStatusCd] = useState('');
    const [answerUniversityCd, setAnswerUniversityCd] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [userId, setUserId] = useState('');
    const [userNm, setUserNm] = useState('');
    const [regDttm, setRegDttm] = useState('');
    const [files, setFiles] = useState([]);
    const [answerPostingCtnt, setAnswerPostingCtnt] = useState('');
    const [answerFiles, setAnswerFiles] = useState([]);
    const [answerUserNm, setAnswerUserNm] = useState('');
    const [answerUserUniversityNm, setAnswerUserUniversityNm] = useState('');
    const [answerRegDttm, setAnswerRegDttm] = useState('');
    const [editPermission, setEditPermission] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const popupRef = useRef(null);

    // 최초 초기화 호출
    useEffect(() => {
        window.scrollTo(0, 0);
        initSearch(params.postingNo);
    }, []);

    const initSearch = (postingNo) => {
        dispatch(
            actionDetail({
                params: { postingNo },
                callback: (result) => {
                    setDetail(result);
                },
            }),
        );
    };

    const setDetail = (result) => {
        if (
            AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN ||
            (AuthenticationUtil.getUserRoleCd() == ROLE.STAFF &&
                AuthenticationUtil.getUserUniversityCd() == result.answerUniversityCd)
        ) {
            setEditPermission(true);
        } else {
            popupRef.current.openAlert('답변 수정 권한이 부족합니다. 질의응답 목록 조회 화면으로 이동합니다.', () => {
                return function () {
                    navigate(COMMUNITY_QNA_PATH);
                };
            });
        }

        setPostingTitleNm(result.postingTitleNm);
        setPostingCtnt(result.postingCtnt);
        setPostingTypeCd(result.postingTypeCd);
        setAnswerStatusCd(result.answerStatusCd);
        setAnswerUniversityCd(result.answerUniversityCd);
        setUserId(result.userId);
        setUserNm(result.userNm);
        setRegDttm(result.regDttm);
        if (NullCheckUtil.isNotEmpty(result.userUniversityCd)) {
            setUniversityNm(
                CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find((el) => el.cd == result.userUniversityCd).cdNm,
            );
        }

        let fileArr = [];
        result.files.forEach((file) => {
            fileArr.push({
                postingNo: file.postingNo,
                fileUid: file.fileUid,
                fileNm: file.fileNm,
                regDttm: file.regDttm,
                noticeTypeCd: file.noticeTypeCd,
            });
        });
        setFiles(fileArr);

        if (result.answerStatusCd == 'ANSWER') {
            setAnswerPostingCtnt(result.answerPostingCtnt);
            setAnswerUserNm(result.answerUserNm);
            setAnswerRegDttm(result.answerRegDttm);
            if (NullCheckUtil.isNotEmpty(result.answerUserUniversityCd)) {
                setAnswerUserUniversityNm(
                    CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find(
                        (el) => el.cd == result.answerUserUniversityCd,
                    ).cdNm,
                );
            }

            let AnswerFileArr = [];
            result.answerFiles.forEach((file) => {
                AnswerFileArr.push({
                    postingNo: file.postingNo,
                    fileUid: file.fileUid,
                    fileNm: file.fileNm,
                    regDttm: file.regDttm,
                    noticeTypeCd: file.noticeTypeCd,
                });
            });
            setAnswerFiles(AnswerFileArr);
        }
    };

    const uploadFileHandler = (result) => {
        setAnswerFiles((arr) => [
            ...arr,
            {
                postingNo: params.postingNo,
                fileUid: result.fileUid,
                fileNm: result.fileNm,
                regDttm: result.regDttm,
                noticeTypeCd: 'ASNWER',
            },
        ]);
    };

    const fileDeleteHandler = (files) => {
        setAnswerFiles(files);
    };

    const handleDelete = () => {
        popupRef.current.openWarning('답변 ' + postingNo + '(를)을 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionRemove({
                        params: { postingNo },
                        callback: (pno) => {
                            popupRef.current.openInfo('게시물 번호 ' + pno + '의 답변이 삭제되었습니다.', () => {
                                return function () {
                                    handleCancel();
                                };
                            });
                        },
                    }),
                );
            };
        });
    };

    const handleCancel = () => {
        var path = COMMUNITY_QNA_DETAIL_PATH + PATH_DELIMITER + postingNo;
        navigate(path);
    };

    const handleConfirm = () => {
        if (validateAnswer()) {
            dispatch(
                actionEdit({
                    params: {
                        postingNo,
                        postingCtnt: answerPostingCtnt,
                        answerStatusCd,
                        postingTitleNm,
                        userId,
                        files: answerFiles,
                    },
                    callback: (pno) => {
                        popupRef.current.openInfo('게시물 번호 ' + pno + '이 수정되었습니다.', () => {
                            return function () {
                                var path = COMMUNITY_QNA_DETAIL_PATH + PATH_DELIMITER + postingNo;
                                navigate(path);
                            };
                        });
                    },
                }),
            );
        }
    };

    const validateAnswer = () => {
        if (!editPermission) {
            popupRef.current.openAlert('로그인하신 사용자의 권한이 부족합니다.');
            return false;
        }
        if (NullCheckUtil.isEmpty(answerPostingCtnt)) {
            popupRef.current.openAlert('답변 내용을 입력해주세요.');
            return false;
        }
        return true;
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>질의응답</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_QNA_EDIT.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_QNA_EDIT.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    <h3 className='cmnty-title faq-tit ico-question'>질의 내용</h3>
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                placeholder='제목을 입력하세요.'
                                disabled={true}
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                        <div className='top-box-row divide'>
                            <div className='form-box mr14'>
                                <SelectionBox
                                    title='문의담당 대학'
                                    value={answerUniversityCd}
                                    size='long'
                                    disabled={true}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    useAll={false}
                                    onChange={(e) => setAnswerUniversityCd(e.target.value)}
                                />
                            </div>
                            <div className='form-box form-box-checkbox'>
                                <BoardPupupCheck
                                    title='비밀글 여부'
                                    disabled={true}
                                    checked={postingTypeCd == 'CONFIDENTIAL'}
                                    onChecked={(e) => {
                                        e.target.checked
                                            ? setPostingTypeCd('CONFIDENTIAL')
                                            : setPostingTypeCd('PUBLIC');
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <TextViewer className='cmnty-textarea-box' value={postingCtnt} />
                    <MultiFileAttachBox
                        className='cmnty-file-box'
                        uploadFileHandler={(e) => {}}
                        files={files}
                        editable={false}
                        erasable={false}
                        fileDeleteHandler={(e) => {}}
                    />
                    <CommunityPostEditorInfoBox userNm={userNm} universityNm={universityNm} regDttm={regDttm} />
                    <div className='divider'></div>
                    <div className='answer-wrap'>
                        <h3 className='cmnty-title faq-tit ico-answer'>답변 내용</h3>
                        <TextEditor
                            className='cmnty-wrt-box'
                            value={answerPostingCtnt}
                            onChange={setAnswerPostingCtnt}
                        />
                        <MultiFileAttachBox
                            className='cmnty-file-box'
                            uploadFileHandler={(e) => uploadFileHandler(e)}
                            files={answerFiles}
                            editable={true}
                            erasable={true}
                            fileDeleteHandler={(e) => fileDeleteHandler(e)}
                        />
                        <CommunityPostEditorInfoBox
                            userNm={answerStatusCd == 'ANSWER' ? answerUserNm : ''}
                            universityNm={answerStatusCd == 'ANSWER' ? answerUserUniversityNm : ''}
                            regDttm={answerStatusCd == 'ANSWER' ? answerRegDttm : ''}
                        />
                    </div>
                    <div className='cmnty-btn-box btn-wrap'>
                        {answerStatusCd == 'ANSWER' && (
                            <CommunityDeleteButtonBox title='답변 삭제' onClick={(e) => handleDelete(e)} />
                        )}
                        <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityQnaEditView;
